<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0 mt-4">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />

            <CTabs variant="pills" class="ml-3 mr-3">

              <!-- PENDING -->
              <CTab title="Pending" active>
                <div v-if="respond.length > 0">
                  <CCard
                    style="border-radius: 10px; height: 150px"
                    class="mr-3 mt-1"
                    v-for="item in respond"
                    v-bind:key="item.Id"
                    @click="GoToTutorProfile(item.notiId, item.teacherId)"
                  >
                    <CCardBody>
                      <CRow>
                        <span style="width: 20%" class="float-left">
                          <span class="custom-header-profile">
                            <img
                              style="
                                width: 50px;
                                height: 50px;
                                object-fit: cover;
                              "
                              src="../../assets/img/icon/icondefault.svg"
                            />
                          </span>
                        </span>
                        <span style="width: 70%" class="float-right">
                          <span>
                            <span class="custom-user-title">
                              {{ item.tutorName }}
                            </span>
                            <label class="custom-label-muted">
                              for {{ item.studentName }} (One to One)
                            </label>
                            <label class="custom-label-muted">
                              {{ item.day }} - {{ item.hour}} 
                            </label>
                            <br />
                            <span>
                              <span class="custom-badge-subject mr-2">
                                {{ item.subjectName }}
                              </span>
                            </span>
                            <br />
                            <!-- {{ item.description }} -->
                          </span>
                          <span>
                            <span class="custom-type-exam">
                              <label class="ml-2">SPM</label>
                            </span>
                          </span>
                          <div style="clear: both"></div>
                        </span>
                        <span style="width: 10%" class="float-right mt-5">
                          <span class="mt-5">
                            <img
                              src="../../assets/img/icon/chevron-right.svg"
                            />
                          </span>
                        </span>
                      </CRow>
                    </CCardBody>
                  </CCard>
                  <br />
                </div>
                <div v-else>
                  <h5 class="text-center mt-5">No Incoming Job</h5>
                  <br />
                  <h6 class="text-center">
                    You will be able to see list of related jobs here
                  </h6>
                </div>
              </CTab>

              <!-- CONFIRMED -->
              <CTab title="Confirmed">
                <div v-if="confirm.length > 0">
                  <CCard
                    style="border-radius: 10px; height: 150px"
                    class="mr-3 mt-1"
                    v-for="item in confirm"
                    v-bind:key="item.Id"
                    @click="GoToTutorProfile(item.notiId, item.teacherId)"
                  >
                    <CCardBody>
                      <CRow>
                        <span style="width: 20%" class="float-left">
                          <span class="custom-header-profile">
                            <img
                              style="
                                width: 50px;
                                height: 50px;
                                object-fit: cover;
                              "
                              src="../../assets/img/icon/icondefault.svg"
                            />
                          </span>
                        </span>
                        <span style="width: 70%" class="float-right">
                          <span>
                            <span class="custom-user-title">
                              {{ item.tutorName }}
                            </span>
                            <label class="custom-label-muted">
                              {{ item.studentName }} (One To One)
                            </label>
                            <br />
                            <label class="custom-label-muted">
                              {{ item.day }} - {{ item.hour }}
                            </label>
                            <br />
                            <span>
                              <span class="custom-badge-subject mr-2">
                                {{ item.subjectName }}
                              </span>
                            </span>
                            <br />
                            <!-- {{ item.description }} -->
                          </span>
                          <span>
                            <span class="custom-type-exam">
                              <label class="ml-2">SPM</label>
                            </span>
                          </span>
                          <div style="clear: both"></div>
                        </span>
                        <span style="width: 10%" class="float-right mt-5">
                          <span class="mt-5">
                            <img
                              src="../../assets/img/icon/chevron-right.svg"
                            />
                          </span>
                        </span>
                      </CRow>
                    </CCardBody>
                  </CCard>
                  <br />
                </div>
                <div v-else>
                  <h5 class="text-center mt-5">No Confirmed Classes</h5>
                  <br />
                  <h6 class="text-center">
                    You will be able to see list of confirmed classes here
                  </h6>
                </div>
              </CTab>

              <!-- HISTORY -->
              <CTab title="History">
                <div v-if="history.length > 0">
                  <CCard
                    style="border-radius: 10px; height: 150px"
                    class="mr-3 mt-1"
                    v-for="item in history"
                    v-bind:key="item.Id"
                    @click="GoToTutorProfileH(item.id, item.teacherId)"
                  >
                    <CCardBody>
                      <CRow>
                        <span style="width: 20%" class="float-left">
                          <span class="custom-header-profile">
                            <img
                              style="
                                width: 50px;
                                height: 50px;
                                object-fit: cover;
                              "
                              src="../../assets/img/icon/icondefault.svg"
                            />
                          </span>
                        </span>
                        <span style="width: 70%" class="float-right">
                          <span>
                            <span class="custom-user-title">
                              {{ item.teacher }}
                            </span>
                            <label class="custom-label-muted">
                              {{ item.studentName }} (One To One)
                            </label>
                            <br />
                            <label class="custom-label-muted">
                              {{ item.checkInTime | moment("dddd") }} - {{ item.checkInTime | moment("H A") }}
                            </label>
                            <br />
                            <span>
                              <span class="custom-badge-subject mr-2">
                                {{ item.subjectName }}
                              </span>
                            </span>
                            <br />
                            <!-- {{ item.description }} -->
                          </span>
                          <span>
                            <span class="custom-type-exam">
                              <label class="ml-2">SPM</label>
                            </span>
                          </span>
                          <div style="clear: both"></div>
                        </span>
                        <span style="width: 10%" class="float-right mt-5">
                          <span class="mt-5">
                            <img
                              src="../../assets/img/icon/chevron-right.svg"
                            />
                          </span>
                        </span>
                      </CRow>
                    </CCardBody>
                  </CCard>
                  <br />
                </div>
                <div v-else>
                  <h5 class="text-center mt-5">No Confirmed Classes</h5>
                  <br />
                  <h6 class="text-center">
                    You will be able to see list of confirmed classes here
                  </h6>
                </div>
              </CTab>

            </CTabs>

            
            <div style="clear: both"></div>
            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /> 
           
          </div>
          
        </div>
      </div>
       
    </CContainer>
    <div class="header-top">Jobs</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoHomePage()" />
    </div>
    <div style="clear: both"></div>

    <div style="clear: both"></div>
  </div>
</template>
<script>
import Vue from "vue";
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';

import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";

import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination,
} from "hooper";

import MainlayoutBottom from "../../containers/TheBottomCustom.vue";

Vue.use(require("vue-moment"));
import moment from "moment";

import "hooper/dist/hooper.css";

export default {
  components: {},
  data: function () {
    return {
      user: {},
      respond: [],
      confirm: [],
      history: [],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  computed: {},
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            // this.GetListWaiting(this.user.id);
            this.GetListRespond(this.user.id);
            this.GetListConfirmed(this.user.id);
            this.GetListHistory(this.user.id);
            
            // this.GetTeacherId(this.user.id);
            // this.GetLisWaitingStudent(this.user.id);
            // this.GetNotificationTeacher(this.user.id);
            // this.GetConfirmationClass(this.$route.query.notiId);
            
          }
        });
    },

    // GetTeacherId() {
    //   this.$API
    //     .get(this.$SelectTeacherId + "?userId=" + this.user.id, {})
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.teaid = response.data;
    //         console.log("teacherid", this.teaid);
    //       }
    //     });
    // },

    

    // GetListWaiting() {
    //   this.$API
    //     .get(
    //       this.$FindTutorListWaitingByLimitAuthorize +
    //         "?start=1&limit=10&userId=" +
    //         this.user.id,
    //       {
    //         withCredentials: true,
    //       }
    //     )
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.waiting = response.data;
    //       }
    //     });
    // },

    GetListRespond() {
      this.$API
        .get(
          this.$FindTutorListToRespondByLimitAuthorize +
            "?userId=" +
            this.user.id,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.respond = response.data;
          }
        });
    },

    GetListConfirmed() {
      this.$API
        .get(
          this.$FindTutorListConfirmedByLimitAuthorize +
            "?userId=" +
            this.user.id,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.confirm = response.data;
          }
        });
    },

    GetListHistory() {
      this.$API
        .get(
          this.$ListClassHistoryStudent +
            "?userId=" +
            this.user.id,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.history = response.data;
          }
        });
    },


    // GetListComplete() {
    //   this.$API
    //     .get(
    //       this.$FindTutorListCompletedByLimitAuthorize +
    //         "?start=1&limit=10&userId=" +
    //         this.user.id,
    //       {
    //         withCredentials: true,
    //       }
    //     )
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.complete = response.data;
    //       }
    //     });
    // },

    GoBack() {
      this.$router.back();
    },
    GoHomePage() {
      this.$router.push("../ExistingUser");
    },

    GoToTutorProfile(notiId, teacherId) {
      this.$router.push(
        "MTTutorProfile?notiId=" +
        notiId +
        "&teacherId=" +
        teacherId
        );
    },

    GoToTutorProfileH(scheduleId, teacherId) {
      this.$router.push(
        "MTTutorProfile?scheduleId=" +
        scheduleId +
        "&teacherId=" +
        teacherId
      );
    },

    GetLisWaitingStudent() {
      this.$API
        .get(
          this.$FindTutorWaitingStudent +
            "?start=1&userId=" +
            this.user.id,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.waitings = response.data;
            console.log("waitingStudent", this.waitings);
          }
        });
    },

  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");


.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: auto;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.progress {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.65625rem;
  border-radius: 0.25rem;
  background-color: #ebedef;
  height: 15px;
  border-radius: 10px;
}
.nav-link .active {
  color: #007cef;
  background-color: transparent;
  border-bottom: 2px solid #007cef;
}
footer .modal-footer {
  display: none;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #000;
  /* background-color: #321fdb; */
  border-bottom: 2px solid #000;
}
</style>




